import { render, staticRenderFns } from "./CreateParent.vue?vue&type=template&id=489a587e&scoped=true"
import script from "./CreateParent.vue?vue&type=script&lang=js"
export * from "./CreateParent.vue?vue&type=script&lang=js"
import style0 from "./CreateParent.vue?vue&type=style&index=0&id=489a587e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489a587e",
  null
  
)

export default component.exports